import React from 'react';
import { Link } from 'react-router-dom';
import { Moon, Mail, MessageCircle, Instagram, Facebook, ArrowRight } from 'lucide-react';
import { Button } from './Button';
export function Footer() {
  return <footer className="bg-midnight-panel border-t border-white/5 pt-24 pb-12 relative overflow-hidden" data-id="element-56">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[1px] bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-57"></div>
      <div className="absolute bottom-0 right-0 w-[800px] h-[800px] bg-primary-glow/10 rounded-full blur-3xl pointer-events-none" data-id="element-58"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-59">
        {/* Top Brand Statement */}
        <div className="mb-20 text-center max-w-3xl mx-auto" data-id="element-60">
          <h2 className="text-3xl md:text-5xl font-serif mb-6 text-cosmic-gradient" data-id="element-61">
            Awaken Your Inner Energy
          </h2>
          <p className="text-beige-muted text-lg" data-id="element-62">
            Transform your life through sacred healing practices rooted in
            ancient wisdom and modern understanding.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-16" data-id="element-63">
          {/* Brand & Newsletter */}
          <div className="lg:col-span-4 space-y-8" data-id="element-64">
            <Link to="/" className="flex items-center gap-3" data-id="element-65">
              <Moon className="w-8 h-8 text-gold" data-id="element-66" />
              <span className="font-serif text-3xl font-medium text-white tracking-wide" data-id="element-67">
                Calmoras
              </span>
            </Link>
            <p className="text-beige-muted text-sm leading-relaxed" data-id="element-68">
              Join our sacred circle to receive weekly cosmic guidance, healing
              rituals, and exclusive insights delivered to your inbox.
            </p>
            <form className="flex gap-2" onSubmit={e => e.preventDefault()} data-id="element-69">
              <input type="email" placeholder="Your email address" className="bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm w-full focus:outline-none focus:border-gold text-white placeholder:text-white/30" data-id="element-70" />
              <Button type="submit" variant="primary" size="sm" icon={<ArrowRight className="w-4 h-4" data-id="element-72" />} data-id="element-71">
                Join
              </Button>
            </form>
            <div className="flex gap-4 pt-4" data-id="element-73">
              <a href="#" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:border-gold hover:text-gold transition-all group" data-id="element-74">
                <Instagram className="w-4 h-4 text-beige group-hover:text-gold" data-id="element-75" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:border-gold hover:text-gold transition-all group" data-id="element-76">
                <Facebook className="w-4 h-4 text-beige group-hover:text-gold" data-id="element-77" />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div className="lg:col-span-2 lg:col-start-6" data-id="element-78">
            <h4 className="font-serif text-xl mb-6 text-white" data-id="element-79">Explore</h4>
            <ul className="space-y-3" data-id="element-80">
              <li data-id="element-81">
                <Link to="/" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-82">
                  Home
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/about" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-84">
                  About
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/services" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-86">
                  Services
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/pricing" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-88">
                  Pricing
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/testimonials" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-90">
                  Testimonials
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-3" data-id="element-91">
            <h4 className="font-serif text-xl mb-6 text-white" data-id="element-92">
              Healing Paths
            </h4>
            <ul className="space-y-3" data-id="element-93">
              <li data-id="element-94">
                <Link to="/services/chakra-balancing" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-95">
                  Chakra Balancing
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/services/aura-cleansing" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-97">
                  Aura Cleansing
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/services/astrology-reading" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-99">
                  Astrology Reading
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/services/energy-healing-therapy" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-101">
                  Energy Healing
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/services" className="text-gold hover:text-gold-light transition-colors text-sm italic mt-2 inline-block" data-id="element-103">
                  View All 22 Services →
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources & Contact */}
          <div className="lg:col-span-3" data-id="element-104">
            <h4 className="font-serif text-xl mb-6 text-white" data-id="element-105">Resources</h4>
            <ul className="space-y-3 mb-8" data-id="element-106">
              <li data-id="element-107">
                <Link to="/blog" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-108">
                  Journal & Insights
                </Link>
              </li>
              <li data-id="element-109">
                <Link to="/contact" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-110">
                  Contact & FAQ
                </Link>
              </li>
              <li data-id="element-111">
                <Link to="/astrology" className="text-beige-muted hover:text-gold transition-colors text-sm" data-id="element-112">
                  Free Astrology Reading
                </Link>
              </li>
            </ul>
            <div className="space-y-3" data-id="element-113">
              <a href="mailto:support@calmoras.online" className="flex items-center gap-3 text-beige-muted hover:text-gold transition-colors" data-id="element-114">
                <Mail className="w-4 h-4 text-gold" data-id="element-115" />
                <span className="text-sm" data-id="element-116">support@calmoras.online</span>
              </a>
              <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-beige-muted hover:text-gold transition-colors" data-id="element-117">
                <MessageCircle className="w-4 h-4 text-[#25D366]" data-id="element-118" />
                <span className="text-sm" data-id="element-119">WhatsApp Support</span>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 mt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/30" data-id="element-120">
          <p data-id="element-121">
            © {new Date().getFullYear()} Calmoras Healing Sanctuary. All rights
            reserved.
          </p>
          <div className="flex gap-2 items-center" data-id="element-122">
            <span className="w-1 h-1 rounded-full bg-gold/50" data-id="element-123"></span>
            <span className="text-gold/50" data-id="element-124">✦</span>
            <span className="w-1 h-1 rounded-full bg-gold/50" data-id="element-125"></span>
          </div>
          <div className="flex gap-6" data-id="element-126">
            <Link to="/privacy" className="hover:text-gold transition-colors" data-id="element-127">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-gold transition-colors" data-id="element-128">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}